import { Alert, Skeleton, Spin, Tabs } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  clearSelectedUserAction,
  readUserAction,
  updateUserAction,
} from "../../store/user/general/userActions";
import UserAgencyRoles from "./UserAgencyRoles";
import UserForm from "./UserForm";
import { userFormTabs } from "./userConstants";

const UpdateUserForm = ({ agencyKeys }) => {
  //
  const { userKey } = useParams();

  //
  const dispatch = useDispatch();

  //
  const loading = useSelector((state) => state.user.general.loading);
  const selectedUser = useSelector((state) => state.user.general.selected);

  //
  useEffect(() => {
    dispatch(readUserAction(userKey));
  }, [userKey, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearSelectedUserAction());
    };
  }, []);

  const onSubmitHandler = (values) => dispatch(updateUserAction(values));

  const isAccessEnabled = selectedUser?.Details?.AccessEnabled || false;
  const items = [
    {
      key: "1",
      label: userFormTabs.GENERAL,
      children: (
        <>
          {selectedUser && (
            <UserForm
              onSubmitHandler={onSubmitHandler}
              initialValues={selectedUser}
              agencyKeys={agencyKeys}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: userFormTabs.SECURITY,
      children: <UserAgencyRoles />,
      disabled: !isAccessEnabled,
    },
  ];

  return (
    <Skeleton active loading={!selectedUser && loading}>
      <Spin spinning={loading} delay={500}>
        {!selectedUser ? (
          <Alert
            type="error"
            message="Something went wrong while loading this user."
            showIcon
          />
        ) : (
          <Tabs defaultActiveKey="1" type="card" size="small" items={items} />
        )}
      </Spin>
    </Skeleton>
  );
};

export default UpdateUserForm;
